import React from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import Attribute from 'marketing/common/attribute';

const ClientsOnly = () => {
  return (
    <div className="error-page l-content">
      <Meta
        title="Page restricted to clients"
        meta={[{ name: "robots", content: "noindex,nofollow" }]}
      />
      <div id="content" className="row">
        <div className="small-16 medium-8 column error-content align-middle">
          <h1>This page is restricted to clients.</h1>
          <p>
            The page you are trying to access is for clients only.
            Please <Link to="/help/">contact our support team</Link> if you have any questions.
          </p>
        </div>
        <div className="small-16 medium-8 columns">
          <div className="error-image">
            {/*<img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_sleeping-sheep-annasmoke.png" alt="Sheep by Annasmoke"/>
            <Attribute to="annasmoke"/>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsOnly;



// WEBPACK FOOTER //
// ./error/components/clients_only.jsx